import api from '../api';
import secureStorage from '../../utils/SecureStorage';

const Buscarredecnpj = async (idrede) => {
  const apiUrl = process.env.REACT_APP_API_BASE_25;

  try {
    const response = await api.get(`${apiUrl}${idrede}`);
    
    
    if (response.data) {
      secureStorage.setItem("datarede", JSON.stringify(response.data));
      return response.data; // Retorna os dados encontrados
    } else {
      console.error("Erro ao buscar cadastros. Veja o console para mais detalhes.");
      return [];
    }
  } catch (error) {
    console.error("Erro ao buscar cadastros. Veja o console para mais detalhes.", error);
    return [];
  }
};

export default Buscarredecnpj;
